import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GuideService } from '../Admin/Guide/services/GuideService';
import { makeStyles } from '@material-ui/core/styles';
import { PropagateLoader } from 'react-spinners';
//import { Worker, Viewer } from '@react-pdf-viewer/core';

//import '@react-pdf-viewer/core/lib/styles/index.css'; // Styles for @react-pdf-viewer/core
//import '@react-pdf-viewer/default-layout/lib/styles/index.css'; // Styles for @react-pdf-viewer/default-layout
import { Helmet } from 'react-helmet-async';

const useStyles = makeStyles(() => ({
  container: {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  title: {
    fontSize: '24px',
    color: '#890608',
  },
  content: {
    marginTop: '20px',
  },
}));

// Define the type for Guide
interface Guide {
  _id: string;
  title: string;
  description: string;
  preview: string;
  pdfUrl: string; // Add pdfUrl to Guide type
}

const GuideDetail = () => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const [guide, setGuide] = useState<Guide | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    GuideService.getGuideById(id)
      .then((response: { data: Guide }) => {
        setGuide(response.data);
        setLoading(false);
      })
      .catch((err: Error) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <PropagateLoader color="#36D7B7" size={15} />
      </div>
    );
  }

  if (!guide) {
    return <div>Guide not found</div>;
  }

  const title = guide.title;
  const description = guide.description;
  const currentUrl = window.location.href;
  const ogImageUrl = guide.preview;
  const ogImageAlt = guide.title;


  return (
    <>
    <Helmet>
        {/* General Meta Tags */}
        <title>{title}</title>
        <meta name="description" content={guide.description} data-rh="true" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={title} data-rh="true" />
        <meta property="og:description" content={description} data-rh="true" />
        <meta property="og:url" content={currentUrl} data-rh="true" />
        <meta property="og:type" content="website" data-rh="true" />
        <meta property="og:site_name" content="AfriqPnB" data-rh="true" />
        <meta property="og:image" content={ogImageUrl} data-rh="true" />
        <meta property="og:image:secure_url" content={ogImageUrl} data-rh="true" />
        <meta property="og:image:type" content="image/webp" data-rh="true" />
        <meta property="og:image:width" content="300" data-rh="true" />
        <meta property="og:image:height" content="300" data-rh="true" />
        <meta property="og:image:alt" content={ogImageAlt} data-rh="true" />
        <link rel="canonical" href={currentUrl} />
      </Helmet>
   
        <div className={classes.container}>
        <h1 className={classes.title}>{guide.title}</h1>
        <div className={classes.content}>
            {/*<img src={guide.preview} alt={guide.title} style={{ width: '100%', height: 'auto' }} /> */}
            <h2>{guide.description}</h2>
            {guide.pdfUrl && (
            {/*<div>
                <Worker workerUrl={`//unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`}>
                <Viewer fileUrl={guide.pdfUrl} />
                </Worker>
            </div> */}
            )}
        </div>
        </div>
    </>
  );
};
export default GuideDetail;
function t(arg0: string) {
    throw new Error('Function not implemented.');
}

